 /**
 * Created by arto on 4.4.2018.
 */

const state = {
    deviceStatuses: []
}

const getters = {
    deviceStatuses: state => state.deviceStatuses
}

const actions = {
    addObservationStatus({commit, state}, observationStatus) {
        commit('addObservationStatus', observationStatus)
    }
}

const mutations = {
    addObservationStatus(state, observationStatus) {
        let deviceId = observationStatus.deviceId
        let loading = observationStatus.loading
        state.deviceStatuses[deviceId] = []
        state.deviceStatuses[deviceId] = loading;
    },
    removeDeviceStatus(state, deviceId) {
        delete state.deviceStatuses[deviceId]
    },
    clearDeviceStatuses(state) {
        state.deviceStatuses = [];
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/app/store/modules/deviceObservationStatuses.js